module.exports = __webpack_public_path__ + "static/img/why-4-4.51a0d63.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/why-4-4.png
// module id = IRIJ
// module chunks = 1